import React from 'react';
import PropTypes from 'prop-types';

import Actions from './actions';

import { Modal, Header, Button, Icon } from 'semantic-ui-react';

// Action manager is a React component that, given an action,
// renders the necessary content and passes the necessary info.
// If extra information is needed, the action can always be connect()()ed
// to redux's store for example

export default class AttendeesActionsManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actionError: null,
            runningAction: null
        };
    }

    componentDidUpdate(previousProps, previousState) {
        if (!previousState.runningAction) {
            this.runAction(this.props.action, previousProps.selectedAttendees);
        }
    }

    /**
     * Run an action
     */
    runAction(action, previousSelectedAttendees) {
        if (!action) {
            return;
        }

        // do not run twice i guess?
        if (this.state.runningAction === action && this.props.selectedAttendees === previousSelectedAttendees) {
            return;
        }

        let component = Actions.find(act => act.name === action);
        if (!component) {
            return;
        }

        this.setState({
            runningAction: component
        });
    }

    /**
     * When an action is done call this
     */
    done() {
        let { runningAction } = this.state;

        this.setState({
            runningAction: null
        });

        this.props.onActionDone(runningAction, this.props.selectedAttendees);
    }

    /**
     * When action errors
     */
    error(error) {
        let { runningAction } = this.state;

        this.setState({
            runningAction: null,
            actionError: error
        });

        this.props.onActionError(runningAction, this.props.selectedAttendees, error);
    }

    /**
     * Displays an action error
     */
    renderActionError() {
        if (!this.state.actionError) {
            // no need to clutter the DOM if no modal needed
            return null;
        }

        return (
            <Modal open={Boolean(this.state.actionError)} basic size="small">
                <Header icon="delete" content={this.state.actionError} />
                <Modal.Actions>
                    <Button basic color="red" inverted onClick={() => this.setState({ actionError: null })}>
                        <Icon name="remove" /> Annuler
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    render() {
        let { event, organization, selectedAttendees, rates, zones } = this.props;

        if (!this.state.runningAction) {
            return null;
        }

        if (this.state.actionError) {
            return this.renderActionError();
        }

        let Component = this.state.runningAction.component;

        if (React.isValidElement(Component)) {
            return Component;
        }

        return (
            <React.Fragment>
                <Component
                    event={event}
                    organization={organization}
                    selectedAttendees={selectedAttendees}
                    rates={rates}
                    zones={zones}
                    done={this.done.bind(this)}
                    error={this.error.bind(this)}
                />
                ;
            </React.Fragment>
        );
    }
}

AttendeesActionsManager.defaultProps = {
    action: null,
    onActionDone: () => {},
    onActionError: () => {},
    zones: null,
    rates: null
};

AttendeesActionsManager.propTypes = {
    action: PropTypes.string,
    event: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    onActionDone: PropTypes.func,
    onActionError: PropTypes.func,
    selectedAttendees: PropTypes.array,
    zones: PropTypes.array,
    rates: PropTypes.array
};
